import { UseScoreRange } from '../../common/hooks/useScoreRange'
import { VALUE_SCORE } from '../../constant'
import { LevelName } from './LevelName'

export const ScoreRangeJpg = ({ typeValue }) => {
  const { data } = UseScoreRange(true)

  const rangeScore =
    typeValue === VALUE_SCORE.CREDIT_SCORE
      ? data['CREDIT_RISK']
      : data['PERFORMANCE']

  return (
    <div className="wh100 pt2">
      {rangeScore.map((item, index) => (
        <div className="pb1" key={index}>
          <LevelName val={item?.scoreRangeId} typeValue={typeValue} />
        </div>
      ))}
    </div>
  )
}
